import { useNavigate } from 'react-router-dom';
import LanguageSelector from './Entities/LanguageSelector';
import logo from './assets/logotypes/logo_white.png';
import './styles/Header.css';

function HelpHeader() {
  const navigate = useNavigate();

  return (
    <header className="help-header-container">
      <div className="icon-group left"></div>
      <div className="logo-center">
        <img
          src={logo}
          className="help-logo-image clickable-logo"
          alt="Logo"
          onClick={() => navigate('/home')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="icon-group right">
        <LanguageSelector />
      </div>
    </header>
  );
}

export default HelpHeader;
